import React, { useContext, useMemo } from 'react'

import { MoreVert as MoreVertIcon } from '@material-ui/icons'

import { Dropdown } from 'react-bootstrap'
import classNames from 'classnames/bind'

import './custom-dropdown.css'

const DropdownMenus = ({
  menuList,
  onSelect,
  className,
  renderToggle = null,
  value = null,
  isDisabled = false,
  show,
  onToggle,
  menuClassName,
  menuStyle,
  popperConfig,
}) => {
  return (
    <Dropdown show={show} onToggle={onToggle}>
      <Dropdown.Toggle
        variant="light"
        className={classNames('btn-toggle', className)}
      >
        {renderToggle ? renderToggle() : <MoreVertIcon />}
      </Dropdown.Toggle>

      <Dropdown.Menu
        className={menuClassName}
        popperConfig={popperConfig}
        style={menuStyle}
      >
        {menuList &&
          menuList
            .filter((x) => !x.hidden)
            .map((item, index) => (
              <Dropdown.Item
                key={index}
                className={value && value?.id === item?.id ? 'active' : ''}
                disabled={
                  (item.disabled || isDisabled) &&
                  item?.name !== 'view-goods-issue'
                }
                onClick={() => {
                  if (onSelect) {
                    onSelect(item)
                  }
                }}
              >
                {item?.icon} {item.title}
              </Dropdown.Item>
            ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default DropdownMenus
